import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faList } from "@fortawesome/pro-regular-svg-icons/faList";

export const defaultTranslations = {
    pluginName: "Sub Category",
    pluginDescription: "Create a sub category",
};

export const defaultSettings = {
    defaultText: "<p>Enter text here.</p>",

    Controls: () => <>Controls for this plugin were not provided</>,
    Renderer: () => <>Renderer for this plugin was not provided</>,
    translations: defaultTranslations,
    IconComponent: <FontAwesomeIcon icon={faList} size="3x" />,
};
